/**
 * Created by jimmy on 2019/3/2.
 */
import React, { Component } from 'react';
import './prd_list.less';
import Page from '../compoment/prj/page';
import * as Utils from '../common/utils';

import IMG_CXYNEW_1 from '../common/images/prdlist/mall/1.jpg';
import IMG_CXYNEW_2 from '../common/images/prdlist/mall/2.jpg';
import IMG_CXYNEW_3 from '../common/images/prdlist/mall/3.jpg';
import IMG_CXYNEW_4 from '../common/images/prdlist/mall/4.jpg';
import IMG_CXYNEW_5 from '../common/images/prdlist/mall/5.jpg';
import IMG_CXYNEW_6 from '../common/images/prdlist/mall/6.jpg';
import IMG_CXYNEW_7 from '../common/images/prdlist/mall/7.jpg';
import IMG_CXYNEW_8 from '../common/images/prdlist/mall/8.jpg';
import IMG_CXYNEW_9 from '../common/images/prdlist/mall/9.jpg';

const IMG_MAP = {
  IMG_CXYNEW_1, IMG_CXYNEW_2, IMG_CXYNEW_3, IMG_CXYNEW_4, IMG_CXYNEW_5, IMG_CXYNEW_6, IMG_CXYNEW_7, IMG_CXYNEW_8, IMG_CXYNEW_9
};

class PageHome extends Component {
  constructor(props) {
    super(props);

    this.state = {

    }
  }

  componentDidMount() {
	  Utils.setTitle('产品列表');
  }


  render() {
    return (
      <section className="prdlist-wrap">
        {
          Object.keys(IMG_MAP).map((img, idx) => (
            <img src={IMG_MAP[img]} key={idx} />
          ))
        }
      </section>
    );
  }
}

export default PageHome;

window.onload=function () {
  if(window.location.pathname == '/prj/citic-call/mall-list') {
    document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width,initial-scale=1')
  }
};
